import React, { useCallback } from "react"
import Formsy from "formsy-react"
import { useCustomName, useModal, useSubmit } from "hooks"
import { FACILITY_KEY } from "utils/customNameHelpers"
import Modal, { ModalHeader } from "shared/Modal"
import { PrimaryButton, Button } from "shared/buttons"
import { FormsyTextInput } from "shared/inputs"
import * as API from "services/api"
import { successToast, errorToast } from "shared/toast"

const CreateFacilityModal = () => {
  const { name: facilityName, nameInSentence: facilityNameInSentence } = useCustomName(FACILITY_KEY)

  const { modalIsOpen, openModal, closeModal } = useModal()
  const { canSubmit, enableSubmit, disableSubmit } = useSubmit(false)

  const createFacility = useCallback(async (model) => {
    const response = await API.createFacility({ facility: model })

    if (response.ok) {
      window.location = `/admin/facilities/${response.data.id}`
      successToast(`${facilityName} created successfully!`)
    } else {
      console.error("Error updating facility: ", response)
      errorToast(`Something went wrong. Unable to create ${facilityNameInSentence}.`, response)
    }
  }, [facilityName, facilityNameInSentence])

  return (
    <>
      <div className="flex justify-center">
        <Button
          text={`+ Add ${facilityName}`}
          onClick={openModal}
          className="text-focus border border-light my-4"
        />
      </div>

      <Modal
        isOpen={modalIsOpen}
        aria={{ label: `new ${facilityNameInSentence}` }}
      >
        <ModalHeader closeModal={closeModal} heading={`New ${facilityName}`} />
        <Formsy
          onSubmit={createFacility}
          onValid={enableSubmit}
          onInvalid={disableSubmit}
        >
          <div className="w-3/4 mx-auto">
            <FormsyTextInput
              className="bordered-base-input text-sm"
              name="name"
              placeholder="Name"
              value=""
              required
              validations={{ isNotBlankString: true }}
              validationErrors={{ isDefaultRequiredValue: "required" }}
            />
            <div className="flex justify-center mt-8">
              <Button
                text="Cancel"
                onClick={closeModal}
                className="border border-light-300 mr-2"
              />
              <PrimaryButton
                text="Create"
                type="submit"
                disabled={!canSubmit}
              />
            </div>
          </div>
        </Formsy>
      </Modal>
    </>
  )
}

export default CreateFacilityModal
